export default __webpack_public_path__ + "static/media/sort.1eec64a2.svg";